/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pagination_PrevInputs */

const cs_pagination_prev = /** @type {(inputs: Pagination_PrevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Předchozí stránka`)
};

const en_pagination_prev = /** @type {(inputs: Pagination_PrevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previous page`)
};

/**
* | output |
* | --- |
* | "Previous page" |
*
* @param {Pagination_PrevInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pagination_prev = /** @type {((inputs?: Pagination_PrevInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pagination_PrevInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pagination_prev(inputs)
	return cs_pagination_prev(inputs)
});